//axios instance
import axiosInstance from '@services/config';
import { BenefitsResponse } from '@interfaces/SportCenters/Benefits';

export const getBenefits = (): Promise<{ data: BenefitsResponse }> =>
  axiosInstance.get('/benefits');
